import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, title }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, pct)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full overflow-hidden select-none touch-none cursor-ew-resize"
      onPointerDown={(e) => {
        dragging.current = true;
        ref.current?.setPointerCapture?.(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => dragging.current && update(e.clientX)}
      onPointerUp={() => (dragging.current = false)}
      onPointerCancel={() => (dragging.current = false)}
    >
      <img src={after} alt={`${title} — after`} className="w-full h-auto block" draggable={false} />
      <img
        src={before}
        alt={`${title} — before`}
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
      />
      <span className="absolute top-3 left-3 bg-[#050505]/80 border border-[#D4AF37] text-[#D4AF37] text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
        Before
      </span>
      <span className="absolute top-3 right-3 bg-[#050505]/80 border border-[#D4AF37] text-[#D4AF37] text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
        After
      </span>
      <div className="absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-[#D4AF37]" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 bg-[#D4AF37] text-[#050505] p-2 rounded-full shadow-lg">
          <MoveHorizontal className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
};
